module.exports = __webpack_public_path__ + "img/reg_mentor.92b12f87.svg";